import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82d3e752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-container" }
const _hoisted_2 = {
  key: 0,
  class: "content-wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "게시글을 삭제하시겠습니까?", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, [
  /*#__PURE__*/_createTextVNode(" 회원 정보에 있는 휴대폰 번호로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 검토결과를 전송해드립니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 신청하시겠습니까? ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          title: "신규 노선/정류장 신청",
          overrideOnClickBack: true,
          onOnClickBack: $setup.handleClickBack
        }),
        ($setup.editMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode($setup["NewRouteApplicationEdit"], {
                createMode: $setup.createMode,
                applicationDetail: $setup.applicationDetail,
                onOnClickAddressInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowAddressSearchMap(true))),
                onOnCompleteEdit: _cache[1] || (_cache[1] = ($event: any) => (
            [$setup.toggleEditMode(false), $setup.getNewRouteDetail($setup.newRouteUid)]
          )),
                onOnUpdateApplicationDetail: $setup.updateApplicationDetail
              }, null, 8 /* PROPS */, ["createMode", "applicationDetail"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ($setup.applicationDetail)
                ? (_openBlock(), _createBlock($setup["NewRouteApplicationDetail"], {
                    key: 0,
                    applicationDetail: $setup.applicationDetail,
                    onOnClickEditBtn: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleEditMode(true))),
                    onOnClickDeleteBtn: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowDeleteConfirmModal(true))),
                    onOnClickReceiveResultBtn: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowReceiveResultConfirmModal(true))),
                    onOnClickMap: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleShowAddressInfoMap(true)))
                  }, null, 8 /* PROPS */, ["applicationDetail"]))
                : _createCommentVNode("v-if", true)
            ]))
      ]),
      ($setup.shouldShowDeleteConfirmModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "삭제하기",
            cancelButtonTitle: "취소",
            onOnClickCancelButton: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleShowDeleteConfirmModal(false))),
            okButtonTitle: "삭제하기",
            onOnClickOkButton: _cache[7] || (_cache[7] = ($event: any) => (
        [$setup.toggleShowDeleteConfirmModal(false), $setup.deleteNewRouteApplication()]
      ))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowReceiveResultConfirmModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 1,
            title: "검토결과 수신 신청",
            cancelButtonTitle: "취소",
            onOnClickCancelButton: _cache[8] || (_cache[8] = ($event: any) => ($setup.toggleShowReceiveResultConfirmModal(false))),
            okButtonTitle: "신청하기",
            onOnClickOkButton: _cache[9] || (_cache[9] = ($event: any) => (
        [$setup.toggleShowReceiveResultConfirmModal(false), $setup.requestReceiveResult()]
      ))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowAddressSearchMap,
        onBackHandler: () => $setup.toggleShowAddressSearchMap(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["AddressSearchMap"], {
            initialAddress: $setup.selectedAddress,
            onOnClickClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.toggleShowAddressSearchMap(false))),
            onOnClickApplyBtn: $setup.setAddressInfo
          }, null, 8 /* PROPS */, ["initialAddress"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowAddressInfoMap,
        onBackHandler: () => $setup.toggleShowAddressInfoMap(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["AddressInfoMap"], {
            address: $setup.address,
            onOnClickClose: _cache[11] || (_cache[11] = ($event: any) => ($setup.toggleShowAddressInfoMap(false)))
          }, null, 8 /* PROPS */, ["address"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}